import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=9c542ff2&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c542ff2')) {
      api.createRecord('9c542ff2', component.options)
    } else {
      api.reload('9c542ff2', component.options)
    }
    module.hot.accept("./DataList.vue?vue&type=template&id=9c542ff2&", function () {
      api.rerender('9c542ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/sales-online/DataList.vue"
export default component.exports